function Partners() {
  if (document.querySelector('.partners__banner')) {
    let options = document.querySelectorAll('.partners__option');

    options.forEach((option) => {
      option.addEventListener('click', () => {
        let body = option.querySelector('.partners__option-body');
        let showClass = 'partners__option-show';
        let scrollValue = 1;

        // фикс кнопки Наверх после завершения анимации
        const scroll = () => {
          window.scrollTo(0, window.scrollY + scrollValue);

          scrollValue *= -1;
        };

        option.classList.toggle(showClass);

        if (option.classList.contains(showClass)) {
          $(body).slideDown(400, scroll);
        } else {
          $(body).slideUp(400, scroll);
        }
      });
    });
  }
}

export default Partners;
